import { injectable, inject } from 'inversify';
import HttpClient from '../../../http';
import {
  BrandsServiceInterface,
  GetBrandsResponse,
  GetBrandsRequest,
} from './BrandsService.types';
import { backendUrl } from 'src/config';

@injectable()
class BrandsService implements BrandsServiceInterface {
  @inject(HttpClient) private client!: HttpClient;

  async getBrands({ origin }: GetBrandsRequest) {
    return await this.client
      .getClient()
      .get<GetBrandsResponse>('/stock/brands/', {
        baseURL: backendUrl,
        ...(origin && {
          params: {
            products__origin_products__origin__slug_name: origin,
          },
        }),
      });
  }
}

export default BrandsService;
